import { render, staticRenderFns } from "./TourList.vue?vue&type=template&id=379839f8&scoped=true&"
import script from "./TourList.vue?vue&type=script&lang=js&"
export * from "./TourList.vue?vue&type=script&lang=js&"
import style0 from "./TourList.vue?vue&type=style&index=0&id=379839f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379839f8",
  null
  
)

export default component.exports